export const state = {
  numberlesslabours: [],
  labour_items: [],
  labour_item: [
    {
      truck_id: "",
      labour_description: "",
      labour_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remark: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/numberlesslabours/state.js